export default "__VITE_ASSET__BBoroOAK__"